module.exports = __webpack_public_path__ + "media/custom/images/img41-07b99c236d04cd271ae9db61100c0dd6.jpg";